"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedListUtil = void 0;
class NestedListUtil {
    /* Build a nested list from display values eg "A > B > C" */
    static build(field, data) {
        const builder = field.Mutator.builder;
        data.forEach((s) => NestedListUtil.fromString(builder, s));
        field.Mutator.init(builder.options);
    }
    static fromString(builder, str) {
        const parts = str.split(' > ');
        let value = builder;
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let group = value.group;
            if (group == null) {
                group = value.createGroup('Group:' + i);
            }
            let foundValue = group.findValue(part);
            if (foundValue == null) {
                foundValue = group.createValue(part);
            }
            value = foundValue;
        }
    }
}
exports.NestedListUtil = NestedListUtil;
//# sourceMappingURL=nested.list.js.map